import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium',
  disabled = false,
  fullWidth = false,
  icon = null,
  type = 'button',
  className = ''
}) => {
  const baseStyle = {
    padding: size === 'small' ? '8px 16px' : size === 'large' ? '14px 28px' : '10px 20px',
    fontSize: size === 'small' ? '13px' : size === 'large' ? '16px' : '14px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '8px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    width: fullWidth ? '100%' : 'auto',
    fontFamily: 'inherit'
  };

  const variants = {
    primary: {
      background: 'var(--primary)',
      color: 'white'
    },
    secondary: {
      background: 'var(--surface)',
      color: 'var(--text-primary)',
      border: '1px solid var(--border)'
    },
    danger: {
      background: '#ef4444',
      color: 'white'
    },
    success: {
      background: '#10b981',
      color: 'white'
    },
    ghost: {
      background: 'transparent',
      color: 'var(--text-primary)',
      border: '1px solid var(--border)'
    }
  };

  const style = { ...baseStyle, ...variants[variant] };

  return (
    <button
      type={type}
      style={style}
      onClick={onClick}
      disabled={disabled}
      className={className}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.opacity = '0.9';
          e.target.style.transform = 'translateY(-1px)';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
        }
      }}
    >
      {icon && <span>{icon}</span>}
      {children}
    </button>
  );
};

export default Button;